import { Button, CircularProgress, Fab, Grid, makeStyles, TextField, Select, MenuItem } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SideNav from '../../components/Admin/SideNav';
import Modal from '../../components/Modal/modal_cancel_save';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { loadRes } from '../../store/res/res.action';
import MUIDataTable from 'mui-datatables';
import axios from '../../axios-default';
import { easySnackbar } from '../../store/Noti/noti.actions';
import join from 'url-join';
import { ApiServerUrl } from '../../config.json';
import NewWarningDialog from '../../components/Dialog/NewWarningDialog';
import { useLang } from '../../util/lang';
import useAuth from '../../hooks/useAuth';

const FormDownloadStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',
        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

const FormDownload = () => {
    const classes = FormDownloadStyles();
    const res = useSelector(({ res }) => res);
    const auth = useAuth();
    const { isAuthenticated } = auth;
    const dispatch = useDispatch();
    const history = useHistory();
    const formDownloadGetLang = useLang('FormDownload');

    const [addFormDownloadModalOpen, setAddFormDownloadModalOpen] = useState(false),
        [addFormDownloadModalError, setAddFormDownloadModalError] = useState(''),
        [modifyFormDownloadModalOpen, setModifyFormDownloadModalOpen] = useState(false),
        [modifyFormDownloadModalError, setModifyFormDownloadModalError] = useState(''),
        [updatedAddFormDownload, setUpdatedAddFormDownload] = useState({}),
        [updatedModifyFormDownload, setUpdatedModifyFormDownload] = useState({}),
        [FormDownload, setFormDownload] = useState([]),
        [LanguageList, setLanguageList] = useState([]),
        [loading, setLoading] = useState(true),
        [isAdminSAdmin, setIsAdminSAdmin] = useState(false),
        [isDistr, setIsDistr] = useState(false),
        [addSelectedFile, setAddSelectedFile] = useState(null),
        [isAddFilePicked, setIsAddFilePicked] = useState(false),
        [modifySelectedFile, setModifySelectedFile] = useState(null),
        [isModifyFilePicked, setIsModifyFilePicked] = useState(false),
        [currentRecordDisplaySequenceNumber, setCurrentRecordDisplaySequenceNumber] = useState(''),
        [currentRecordDisplayGroup, setCurrentRecordDisplayGroup] = useState(''),
        [closeAddFormDownloadModalWarningOpen, setCloseAddFormDownloadModalWarningOpen] = useState(false),
        [closeModifyFormDownloadModalWarningOpen, setCloseModifyFormDownloadModalWarningOpen] = useState(false),
        [deleteFormDownloadWarningOpen, setDeleteFormDownloadWarningOpen] = useState(false),
        [deleteFormDownloadID, setDeleteFormDownloadID] = useState(''),
        [fileUrl, setFileUrl] = useState('');

    const obj = {};
    var langList = {};

    useEffect(() => {
        (async () => {
            try {
                langList = (await axios.get('lang/list')).data.lang.map(
                    (v) => Object.assign((v, { lang_iso_code: v.lang_iso_code }), {}) ?? {}
                );
                setLanguageList(langList);
                setLoading(false);
                setUpdatedAddFormDownload({});
                setUpdatedModifyFormDownload({});
            } catch (err) {
                console.error(err);
                if (err.response && err.response.statusText === 'Unauthorized') {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('expirationDate');
                    localStorage.removeItem('role');
                    history.push('/login');
                }
            }
        })();
    }, []);

    useEffect(() => {
        if ((localStorage.role == '"SADMIN"') | (localStorage.role == '"ADMIN"')) {
            setIsAdminSAdmin(true);
        } else if (localStorage.role == '"DISTR"') {
            setIsDistr(true);
        }
    }, []);

    useEffect(() => {
        setCurrentRecordDisplaySequenceNumber(updatedModifyFormDownload.display_sequence_number);
        setCurrentRecordDisplayGroup(updatedModifyFormDownload.distr_group_id);
    }, [modifyFormDownloadModalOpen, currentRecordDisplaySequenceNumber, currentRecordDisplayGroup]);

    useEffect(() => {
        (async () => {
            try {
                Object.keys(res.form_download).forEach((key1) => {
                    Object.keys(res.form_download[key1]).forEach((key2) => {
                        obj[res.form_download[key1][key2].form_download_id] = res.form_download[key1][key2];
                    });
                });

                if (isAdminSAdmin) {
                    var obj1 = Object.values(obj)
                        .filter((a) => a.distr_group_name == 'ALL')
                        .sort((a, b) => a.display_sequence_number - b.display_sequence_number)
                        .map((g) => ({
                            distributor_group_name: g.distr_group_name,
                            display_sequence_number: g.display_sequence_number,
                            language: g.lang_iso_code,
                            form_description: g.form_description,
                            form_file: g.form_file_name,
                            id: g,
                        }));

                    var obj2 = Object.values(obj)
                        .filter((c) => c.distr_group_name != 'ALL')
                        .sort((c, d) => c.display_sequence_number - d.display_sequence_number)
                        .sort((c, d) => c.distr_group_name.localeCompare(d.distr_group_name))
                        .map((g) => ({
                            distributor_group_name: g.distr_group_name,
                            display_sequence_number: g.display_sequence_number,
                            language: g.lang_iso_code,
                            form_description: g.form_description,
                            form_file: g.form_file_name,
                            id: g,
                        }));

                    setFormDownload(obj1.concat(obj2));
                } else if (isDistr) {
                    setFormDownload(
                        Object.values(obj)
                            .filter((a) => a.distr_group_id == localStorage.distr_group_id.replace(/['"]+/g, ''))
                            .sort((a, b) => a.display_sequence_number - b.display_sequence_number)
                            .map((g) => ({
                                distributor_group_name: g.distr_group_name,
                                display_sequence_number: g.display_sequence_number,
                                language: g.lang_iso_code,
                                form_description: g.form_description,
                                form_file: g.form_file_name,
                                id: g,
                            }))
                    );
                }

                setLoading(false);
                setUpdatedAddFormDownload({});
                setUpdatedModifyFormDownload({});
            } catch (err) {
                console.error(err);
                if (err.response && err.response.statusText === 'Unauthorized') {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('expirationDate');
                    localStorage.removeItem('role');
                    history.push('/login');
                }
            }
        })();
    }, [res.form_download, isAdminSAdmin, isDistr]);

    const Columns = useMemo(
        () => [
            {
                name: 'distributor_group_name',
                label: formDownloadGetLang('distributorGroupName'),
                options: {
                    filter: true,
                    sort: true,
                    display: isAdminSAdmin,
                },
            },
            {
                name: 'display_sequence_number',
                label: formDownloadGetLang('displaySequenceNumber'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'language',
                label: formDownloadGetLang('language'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'form_description',
                label: formDownloadGetLang('formDescription'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'form_file',
                label: formDownloadGetLang('formFile'),
                options: {
                    filter: true,
                    sort: true,
                },
            },
            {
                name: 'id',
                label: formDownloadGetLang('action'),
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ display: 'flex' }}>
                                <Fab
                                    size="small"
                                    aria-label="add"
                                    style={{
                                        backgroundColor: '#75a0de',
                                        color: 'white',
                                        margin: '0px 4px',
                                    }}
                                    onClick={() => {
                                        setUpdatedModifyFormDownload(Object.assign({}, value));
                                        setModifyFormDownloadModalOpen(true);
                                    }}
                                >
                                    <EditIcon />
                                </Fab>
                                <Fab
                                    size="small"
                                    aria-label="add"
                                    style={{
                                        backgroundColor: '#da5851',
                                        color: 'white',
                                        margin: '0px 4px',
                                    }}
                                    onClick={() => {
                                        setDeleteFormDownloadID(value.form_download_id);
                                        setDeleteFormDownloadWarningOpen(true);
                                    }}
                                >
                                    <DeleteOutlineIcon />
                                </Fab>
                            </div>
                        );
                    },
                },
            },
        ],
        [isAdminSAdmin, deleteFormDownloadWarningOpen, deleteFormDownloadID]
    );

    const reloadPage = async () => {
        const curPage = window.location.pathname;
        history.push('/blank');
        history.replace(curPage);
        await loadRes(isAuthenticated)(dispatch);
    };

    const handleAddUpdate = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedAddFormDownload({
                    ...updatedAddFormDownload,
                    [field]: value,
                });
            },
        [updatedAddFormDownload]
    );

    const handleModifyUpdate = useCallback(
        (field) =>
            ({ target: { value } }) => {
                setUpdatedModifyFormDownload({
                    ...updatedModifyFormDownload,
                    [field]: value,
                });
            },
        [updatedModifyFormDownload]
    );

    const handleAddSave = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);
            if (isDistr) {
                updatedAddFormDownload.distr_group_id = localStorage.distr_group_id.replace(/['"]+/g, '');
            }

            Object.keys(res.form_download).forEach((key1) => {
                Object.keys(res.form_download[key1]).forEach((key2) => {
                    obj[res.form_download[key1][key2].form_download_id] = res.form_download[key1][key2];
                });
            });

            if (String.isBlank(updatedAddFormDownload.distr_group_id)) {
                return setAddFormDownloadModalError('Distributor Group Name is required');
            } else if (String.isBlank(updatedAddFormDownload.lang_id)) {
                return setAddFormDownloadModalError('Language is required');
            } else if (String.isBlank(updatedAddFormDownload.form_description)) {
                return setAddFormDownloadModalError('Form Description is required');
            } else if (String.isBlank(updatedAddFormDownload.form_file)) {
                return setAddFormDownloadModalError('Form File is required');
            }

            updatedAddFormDownload.form_pdf = addSelectedFile;

            const formData = new FormData();
            formData.append('distr_group_id', updatedAddFormDownload.distr_group_id);
            formData.append('lang_id', updatedAddFormDownload.lang_id);
            formData.append('form_description', updatedAddFormDownload.form_description);
            formData.append('form_pdf', updatedAddFormDownload.form_pdf);
            await axios.post(`res/formdownload`, formData);

            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Form Download record saved successfully', 'success'));
            reloadPage();
            setLoading(true);
            setAddFormDownloadModalOpen(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.push('/login');
            } else {
                dispatch(easySnackbar(err.response?.data?.message ?? err.message ?? err, 'error'));
            }
        } finally {
            setLoading(false);
        }
    }, [updatedAddFormDownload, addSelectedFile, isAddFilePicked]);

    const handleModifySave = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);
            if (isDistr) {
                updatedModifyFormDownload.distr_group_id = localStorage.distr_group_id.replace(/['"]+/g, '');
            }
            Object.keys(res.form_download).forEach((key1) => {
                Object.keys(res.form_download[key1]).forEach((key2) => {
                    obj[res.form_download[key1][key2].form_download_id] = res.form_download[key1][key2];
                });
            });

            if (String.isBlank(updatedModifyFormDownload.distr_group_id.toString())) {
                return setModifyFormDownloadModalError('Distributor Group Name is required');
            } else if (String.isBlank(updatedModifyFormDownload.display_sequence_number.toString())) {
                return setModifyFormDownloadModalError('Display Sequence Number is required');
            } else if (
                parseInt(updatedModifyFormDownload.display_sequence_number) <= 0 ||
                parseInt(updatedModifyFormDownload.display_sequence_number) > 999999
            ) {
                return setModifyFormDownloadModalError('Valid Display Sequence Number is between 1 to 999999');
            } else if (String.isBlank(updatedModifyFormDownload.lang_id.toString())) {
                return setModifyFormDownloadModalError('Language is required');
            } else if (String.isBlank(updatedModifyFormDownload.form_description)) {
                return setModifyFormDownloadModalError('Form Description is required');
            } else if (String.isBlank(updatedModifyFormDownload.form_file_name)) {
                return setModifyFormDownloadModalError('Form File is required');
            }

            updatedModifyFormDownload.form_pdf = modifySelectedFile;

            const formData = new FormData();
            formData.append('distr_group_id', updatedModifyFormDownload.distr_group_id);
            formData.append('lang_id', updatedModifyFormDownload.lang_id);
            formData.append('form_description', updatedModifyFormDownload.form_description);
            formData.append('form_pdf', updatedModifyFormDownload.form_pdf);
            formData.append('display_sequence_number', updatedModifyFormDownload.display_sequence_number);
            formData.append('current_display_group_id', currentRecordDisplayGroup);
            formData.append('current_display_sequence_number', currentRecordDisplaySequenceNumber);
            await axios.put(`res/formdownload/${updatedModifyFormDownload.form_download_id}`, formData);
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Form Download record saved successfully', 'success'));
            reloadPage();
            setLoading(true);
            setModifyFormDownloadModalOpen(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.push('/login');
            } else {
                dispatch(easySnackbar(err.response?.data?.message ?? err.message ?? err, 'error'));
            }
        } finally {
            setLoading(false);
        }
    }, [
        updatedModifyFormDownload,
        currentRecordDisplaySequenceNumber,
        currentRecordDisplayGroup,
        modifySelectedFile,
        isModifyFilePicked,
    ]);

    const distriGroupNameSelect = useMemo(
        () =>
            Object.entries(res.distr_groups)
                .filter(([a, b]) => b.distr_group_name == 'ALL')
                .map(([n, c]) => (
                    <MenuItem value={n} key={n}>
                        {c.distr_group_name}
                    </MenuItem>
                ))
                .concat(
                    Object.entries(res.distr_groups)
                        .filter(([a, b]) => b.distr_group_name != 'ALL')
                        .sort(([a, b], [c, d]) => b.distr_group_name.localeCompare(d.distr_group_name))
                        .map(([n, c]) => (
                            <MenuItem value={n} key={n}>
                                {c.distr_group_name}
                            </MenuItem>
                        ))
                ),
        [res?.distr_groups]
    );

    const langIsoCodeSelect = useMemo(
        () =>
            Object.entries(LanguageList).map(([n, c]) => (
                <MenuItem value={(parseInt(n) + 1).toString()} key={(parseInt(n) + 1).toString()}>
                    {c.lang_iso_code}
                </MenuItem>
            )),
        [LanguageList]
    );

    const currentSystemLang =
        localStorage.lang.replace(/['"]+/g, '') == 'en' ? 'English' : localStorage.lang.replace(/['"]+/g, '');
    const currentSystemLangId = (
        parseInt(LanguageList.map((e) => e.lang_iso_code).indexOf(currentSystemLang)) + 1
    ).toString();

    const changeAddHandler = (event) => {
        const file = event.target.files[0];

        if (file.size > 10 * 1024 * 1024) {
            setAddFormDownloadModalError('File size Cannot exceed 10MB.');
            return;
        } else if (file.type != 'application/pdf') {
            setAddFormDownloadModalError('Please upload Form File in PDF format.');
            return;
        } else {
            setAddFormDownloadModalError('');
        }

        const url = URL.createObjectURL(file, { type: 'application/pdf' });

        setAddSelectedFile(file);
        setIsAddFilePicked(true);
        setFileUrl(url);
    };

    const changeModifyHandler = (event) => {
        const file = event.target.files[0];

        if (file.size > 10 * 1024 * 1024) {
            setModifyFormDownloadModalError('File size Cannot exceed 10MB.');
            return;
        } else if (file.type != 'application/pdf') {
            setModifyFormDownloadModalError('Please upload Form File in PDF format.');
            return;
        } else {
            setModifyFormDownloadModalError('');
        }

        const url = URL.createObjectURL(file, { type: 'application/pdf' });

        setModifySelectedFile(file);
        setIsModifyFilePicked(true);
        setFileUrl(url);
    };

    return (
        <div>
            <SideNav />
            <Grid container className={classes.rootContainer}></Grid>
            <Grid container className={classes.rootContainer} style={{ marginTop: 0 }}>
                {!loading ? (
                    <div style={{ display: 'contents' }}>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <h1
                                    style={{
                                        marginBlockEnd: 0,
                                    }}
                                >
                                    {formDownloadGetLang('formDownload')}
                                </h1>

                                <hr />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 8 }}>
                                <Button className={classes.linkBtn} onClick={() => setAddFormDownloadModalOpen(true)}>
                                    {formDownloadGetLang('addFormDownload')}
                                </Button>
                                <MUIDataTable
                                    title={formDownloadGetLang('formDownload')}
                                    data={FormDownload}
                                    columns={Columns}
                                    options={{
                                        download: false,
                                        filterType: 'dropdown',
                                        responsive: 'scroll',
                                        selectableRows: false,
                                        rowsPerPage: 30,
                                        rowsPerPageOptions: [15, 30, 50],
                                    }}
                                />
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={closeAddFormDownloadModalWarningOpen}
                                    setOpen={setCloseAddFormDownloadModalWarningOpen}
                                    onOk={() => {
                                        setCloseAddFormDownloadModalWarningOpen(false);
                                        setAddFormDownloadModalOpen(false);
                                        setUpdatedAddFormDownload({});
                                        setIsAddFilePicked(false);
                                        setAddSelectedFile(null);
                                        setAddFormDownloadModalError('');
                                    }}
                                >
                                    If you cancel, updated information will NOT be saved.
                                </NewWarningDialog>
                                <Modal
                                    className="modal"
                                    modal="Form Download"
                                    title="Add Form Download"
                                    open={addFormDownloadModalOpen}
                                    handleClose={() => setCloseAddFormDownloadModalWarningOpen(true)}
                                    handleDataSave={() => handleAddSave()}
                                    modalError={addFormDownloadModalError}
                                    submitButton={true}
                                >
                                    <>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Please input all the fields</p>
                                        </Grid>
                                        {isAdminSAdmin && (
                                            <Grid item xs={12} style={{ padding: 4 }}>
                                                <p>Distributor Group Name</p>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleAddUpdate('distr_group_id')}
                                                    style={{ width: '100%' }}
                                                    value={updatedAddFormDownload.distr_group_id}
                                                >
                                                    {distriGroupNameSelect}
                                                </Select>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Language</p>
                                            <Select
                                                displayEmpty
                                                onChange={handleAddUpdate('lang_id')}
                                                style={{ width: '100%' }}
                                                value={
                                                    !updatedAddFormDownload.lang_id ||
                                                    updatedAddFormDownload.lang_id == 0
                                                        ? (updatedAddFormDownload.lang_id = currentSystemLangId)
                                                        : updatedAddFormDownload.lang_id
                                                }
                                            >
                                                {langIsoCodeSelect}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Form Description (Maximum 50 Characters)</p>
                                            <TextField
                                                id="form_description"
                                                style={{ width: '100%' }}
                                                value={updatedAddFormDownload.form_description}
                                                onChange={handleAddUpdate('form_description')}
                                                inputProps={{ maxLength: 50 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Form File (Maximum 10 MB)</p>
                                            {isAddFilePicked ? (
                                                <>
                                                    <span style={{ paddingLeft: 4 }}>Existing Form File : &nbsp;</span>
                                                    <a href={fileUrl} target="_blank">
                                                        <span>
                                                            {(updatedAddFormDownload.form_file = addSelectedFile.name)}
                                                        </span>
                                                    </a>
                                                    <p>
                                                        Please upload new Form File in PDF format if replacement needed
                                                    </p>
                                                </>
                                            ) : (
                                                <p>Please upload Form File in PDF format</p>
                                            )}

                                            <Button
                                                variant="contained"
                                                component="label"
                                                style={{
                                                    backgroundColor: '#593687',
                                                    color: 'white',
                                                    fontSize: '30px',
                                                    width: '30px',
                                                    height: '35px',
                                                }}
                                            >
                                                +
                                                <input
                                                    type="file"
                                                    name="file"
                                                    onChange={changeAddHandler}
                                                    hidden
                                                    accept="application/pdf"
                                                />
                                            </Button>
                                        </Grid>
                                    </>
                                </Modal>
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={closeModifyFormDownloadModalWarningOpen}
                                    setOpen={setCloseModifyFormDownloadModalWarningOpen}
                                    onOk={() => {
                                        setCloseModifyFormDownloadModalWarningOpen(false);
                                        setModifyFormDownloadModalOpen(false);
                                        setUpdatedModifyFormDownload({});
                                        setIsModifyFilePicked(false);
                                        setModifySelectedFile(null);
                                        setModifyFormDownloadModalError('');
                                    }}
                                >
                                    If you cancel, updated information will NOT be saved.
                                </NewWarningDialog>
                                <Modal
                                    className="modal"
                                    modal="Form Download"
                                    title="Modify Form Download"
                                    open={modifyFormDownloadModalOpen}
                                    handleClose={() => setCloseModifyFormDownloadModalWarningOpen(true)}
                                    handleDataSave={() => handleModifySave()}
                                    modalError={modifyFormDownloadModalError}
                                    submitButton={true}
                                >
                                    <>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Please input all the fields</p>
                                        </Grid>
                                        {isAdminSAdmin && (
                                            <Grid item xs={12} style={{ padding: 4 }}>
                                                <p>Distributor Group Name</p>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleModifyUpdate('distr_group_id')}
                                                    style={{ width: '100%' }}
                                                    value={updatedModifyFormDownload.distr_group_id}
                                                >
                                                    {distriGroupNameSelect}
                                                </Select>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Display Sequence Number (Automatically resequencing when necessary)</p>
                                            <TextField
                                                id="display_sequence_number"
                                                style={{ width: '100%' }}
                                                value={updatedModifyFormDownload.display_sequence_number}
                                                onChange={handleModifyUpdate('display_sequence_number')}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Language</p>
                                            <Select
                                                displayEmpty
                                                onChange={handleModifyUpdate('lang_id')}
                                                style={{ width: '100%' }}
                                                value={updatedModifyFormDownload.lang_id}
                                            >
                                                {langIsoCodeSelect}
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Form Description (Maximum 50 Characters)</p>
                                            <TextField
                                                id="form_description"
                                                style={{ width: '100%' }}
                                                value={updatedModifyFormDownload.form_description}
                                                onChange={handleModifyUpdate('form_description')}
                                                inputProps={{ maxLength: 50 }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} style={{ padding: 4 }}>
                                            <p>Form File (Maximum 10 MB)</p>
                                            <span style={{ paddingLeft: 4 }}>Existing Form File : &nbsp;</span>
                                            {isModifyFilePicked ? (
                                                <a href={fileUrl} target="_blank">
                                                    <span>
                                                        {
                                                            (updatedModifyFormDownload.form_file_name =
                                                                modifySelectedFile.name)
                                                        }
                                                    </span>
                                                </a>
                                            ) : (
                                                <>
                                                    {updatedModifyFormDownload.form_file_path == undefined ? null : (
                                                        <a
                                                            href={join(
                                                                ApiServerUrl,
                                                                '/file/formOrKnowledge?path=',
                                                                updatedModifyFormDownload.form_file_path,
                                                                '&fileName=',
                                                                updatedModifyFormDownload.form_file_name
                                                            )}
                                                            target="_blank"
                                                        >
                                                            {updatedModifyFormDownload.form_file_name}
                                                        </a>
                                                    )}
                                                </>
                                            )}
                                            <p>Please upload new Form File in PDF format if replacement needed</p>

                                            <Button
                                                variant="contained"
                                                component="label"
                                                style={{
                                                    backgroundColor: '#593687',
                                                    color: 'white',
                                                    fontSize: '30px',
                                                    width: '30px',
                                                    height: '35px',
                                                }}
                                            >
                                                +
                                                <input
                                                    type="file"
                                                    name="file"
                                                    onChange={changeModifyHandler}
                                                    hidden
                                                    accept="application/pdf"
                                                />
                                            </Button>
                                        </Grid>
                                    </>
                                </Modal>
                                <NewWarningDialog
                                    title="Warning Message:"
                                    open={deleteFormDownloadWarningOpen}
                                    setOpen={setDeleteFormDownloadWarningOpen}
                                    onOk={async () => {
                                        try {
                                            const { data } = await axios.delete(
                                                `res/formdownload/${deleteFormDownloadID}`
                                            );
                                            if (data.success) {
                                                setLoading(true);
                                                reloadPage();
                                                dispatch(
                                                    easySnackbar(
                                                        'Form Download record deleted successfully.',
                                                        'success'
                                                    )
                                                );
                                            } else {
                                                console.error(data.message);
                                            }
                                        } catch (err) {
                                            console.error(err);
                                            if (err.response && err.response.statusText === 'Unauthorized') {
                                                localStorage.removeItem('auth-token');
                                                localStorage.removeItem('expirationDate');
                                                localStorage.removeItem('role');
                                                history.push('/login');
                                            }
                                        }
                                        setDeleteFormDownloadWarningOpen(false);
                                    }}
                                >
                                    Are you going to delete this Form Download record?
                                </NewWarningDialog>
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
};
export default FormDownload;
